var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoCheckRevisadoBirdyback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.999 29.5961C23.0557 29.5961 29.5869 23.0649 29.5869 15.0082C29.5869 6.9515 23.0557 0.420288 14.999 0.420288C6.94237 0.420288 0.411133 6.9515 0.411133 15.0082C0.411133 23.0649 6.94237 29.5961 14.999 29.5961Z",
    fill: "#FFBB69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.73352 30 0 23.2747 0 15C0 6.72528 6.72528 0 15 0C23.2747 0 30 6.72528 30 15C30 23.2747 23.2747 30 15 30ZM15 0.832425C7.18682 0.832425 0.824175 7.1868 0.824175 15.0082C0.824175 22.8296 7.17858 29.184 15 29.184C22.8214 29.184 29.1758 22.8296 29.1758 15.0082C29.1758 7.1868 22.8214 0.832425 15 0.832425Z",
    fill: "#E57D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62695 16.2694L12.0253 21.6677L23.366 8.34082",
    fill: "#FFBB69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0253 22.4917C11.8111 22.4917 11.5968 22.4011 11.4402 22.2527L6.04185 16.8544C5.72042 16.5329 5.72042 16.0137 6.04185 15.6923C6.36328 15.3709 6.88249 15.3709 7.20392 15.6923L11.9759 20.4642L22.7396 7.8214C23.0363 7.47524 23.5556 7.43405 23.9017 7.73075C24.2479 8.02745 24.2891 8.54669 23.9924 8.89284L12.6517 22.2197C12.5034 22.3928 12.2891 22.5 12.0583 22.5082C12.0501 22.5082 12.0336 22.5082 12.0253 22.5082V22.4917Z",
    fill: "#E57D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCheckRevisadoBirdyback);
export default __webpack_public_path__ + "static/media/icono-check-revisado-birdyback.9ded9453231871af95023c25b9c77247.svg";
export { ForwardRef as ReactComponent };